import { useSelector } from 'react-redux';

import { selectResources } from './store/selectors';
import { getLocalizedDate, getLocalizedIssueDate, getLocalizedString, getLocalizedStringWithDefault, getLocalizedStringWithFallback } from './common';

export function useResources() {
    const resources = useSelector(selectResources);

    const localizedString = getLocalizedString(resources);
    const localizedStringWithFallback = getLocalizedStringWithFallback(resources);
    const localizedStringWithDefault = getLocalizedStringWithDefault(resources);

    /**
     * @example 'dddd, dd-MM-yyyy'
     *          'ddd, dd-MM-yyyy'
     *          'dd-MM-yyyy'
     *          'd-MMM-yy'
     *          'd-MMMM-y'
     *          'h:mm TT'
     */
    const localizedDate = getLocalizedDate(resources);

    /**
     * Uses `v7.Client.DateFormat.Issue` for formatting.
     * @param short - Set true to only format date and mounth if the year is current year
     */
    const localizedIssueDate = getLocalizedIssueDate(resources);

    return { localizedString, localizedStringWithFallback, localizedStringWithDefault, localizedDate, localizedIssueDate };
}
